module.exports = __webpack_public_path__ + "static/media/notre-dame-hingham.0deb8228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/notre-dame-hingham.jpg
// module id = 628
// module chunks = 0